/* global CustomEvent */
// Funktion zum Aktivieren/Deaktivieren eines Buttons und das Hinzufügen/Entfernen der Klasse im HTML
// eslint-disable-next-line no-unused-vars
function toggleActiveButton (buttonId, toggleFunction, htmlClass) {
  const button = document.querySelector(`#${buttonId}`)
  const html = document.documentElement // Zugriff auf den <html> Tag

  // Toggle den Button Status
  button.classList.toggle('active')

  // Wenn der Button aktiv ist, füge die HTML-Klasse hinzu, sonst entferne sie
  if (button.classList.contains('active')) {
    html.classList.add(htmlClass)
    localStorage.setItem(htmlClass, 'true') // Speichere die Einstellung
  } else {
    html.classList.remove(htmlClass)
    localStorage.removeItem(htmlClass) // Entferne die Einstellung
  }

  // Führe die Funktion für die Barrierefreiheit aus
  toggleFunction() // Diese Funktion sollte korrekt aufgerufen werden
}

// Konstanten für die einfache benutzung. 
const playAnimationsButton = document.querySelector('#playAnimationsButton')
const largeTextButton = document.querySelector('#largeTextButton')
const hideImagesButton = document.querySelector('#hideImagesButton')

function toggleLargeText () {
  const html = document.documentElement
  html.classList.toggle('large-text')
  const isActive = html.classList.contains('large-text')
  if (isActive) {
    localStorage.setItem('large-text', 'true')
  } else {
    localStorage.removeItem('large-text')
  }

  // Event für alle Subscriber dispatchen
  document.dispatchEvent(new CustomEvent('a11y:largeTextToggled', { detail: { isActive } }))
}


// Funktionen zum Anpassen der Barrierefreiheit
function toggleContrast () {
  const html = document.documentElement
  html.classList.toggle('high-contrast')
  const isActive = html.classList.contains('high-contrast')
  if (isActive) {
    localStorage.setItem('high-contrast', 'true')
  } else {
    localStorage.removeItem('high-contrast')
  }

  // Event für alle Subscriber dispatchen
  document.dispatchEvent(new CustomEvent('a11y:contrastToggled', { detail: { isActive } }))
}

function toggleAnimations () {
  const html = document.documentElement
  const videos = document.querySelectorAll('video')

  // Toggle der Animationseinstellungen
  const animationsEnabled = !html.classList.toggle('disable-animations')

  // Video-Eigenschaften aus dem Local Storage abrufen
  const videoSettings = JSON.parse(localStorage.getItem('videoSettings')) || { parentClasses: [] }

  for (const [index, video] of videos.entries()) {
    const parent = video.parentElement
    const hadAutoplayClassInitially = videoSettings.parentClasses[index]?.hadAutoplayClassInitially

    if (parent) {
      if (animationsEnabled) {
        // Animationen aktiv
        video.autoplay = true
        video.loop = true
        video.controls = false

        // Setze die autoplay-Klasse zurück, wenn sie zuvor existierte
        if (hadAutoplayClassInitially) {
          parent.classList.add('jonnitto-prettyembed--autoplay')
          parent.classList.remove('jonnitto-prettyembed--init', 'jonnitto-prettyembed--play')
        }

        // Manuell abspielen, wenn Autoplay aktiviert ist
        video.play().catch(error => {
          console.warn('Autoplay konnte nicht ausgeführt werden:', error)
        })
      } else {
        // Animationen deaktiviert
        video.autoplay = false
        video.loop = false
        video.controls = true

        // Entferne die autoplay-Klasse und setze die Initialisierungs-Klassen
        parent.classList.remove('jonnitto-prettyembed--autoplay')
        parent.classList.add('jonnitto-prettyembed--init', 'jonnitto-prettyembed--play')
      }
    }

    // Aktualisiere das Video, um Änderungen zu übernehmen
    video.load()
  }

  // Speichere den Status von disable-animations
  if (animationsEnabled) {
    localStorage.removeItem('disable-animations')
  } else {
    localStorage.setItem('disable-animations', 'true')
  }

  // Speichere die Video-Eigenschaften im Local Storage
  localStorage.setItem('videoSettings', JSON.stringify({
    parentClasses: [...videos].map((video) => {
      const parent = video.parentElement
      return {
        hadAutoplayClassInitially: parent.classList.contains('jonnitto-prettyembed--autoplay')
      }
    })
  }))

  // Event für alle Subscriber dispatchen (isActive = Animationen deaktiviert)
  const isActive = !animationsEnabled
  document.dispatchEvent(new CustomEvent('a11y:animationsToggled', { detail: { isActive } }))
}

function applyStoredSettings () {
  const html = document.documentElement // Zugriff auf den <html> Tag

  // Setze High Contrast
  if (localStorage.getItem('high-contrast') === 'true') {
    html.classList.add('high-contrast')
    document.querySelector('#highContrastButton').classList.add('active')
  }

  // Setze Large Text
  if (localStorage.getItem('large-text') === 'true') {
    html.classList.add('large-text')
    largeTextButton?.classList.add('active')
  }

  // Setze disable-animations
  const disableAnimations = localStorage.getItem('disable-animations') === 'true'
  if (disableAnimations) {
    html.classList.add('disable-animations')
    playAnimationsButton?.classList.add('active')
  }

  // Stelle die Video-Eigenschaften wieder her
  const videoSettings = JSON.parse(localStorage.getItem('videoSettings')) || { parentClasses: [] }
  const videos = document.querySelectorAll('video')

  for (const [index, video] of videos.entries()) {
    const parent = video.parentElement
    const hadAutoplayClassInitially = videoSettings.parentClasses[index]?.hadAutoplayClassInitially

    if (parent) {
      // Wiederherstellen der Eigenschaften
      if (disableAnimations) {
        video.autoplay = false
        video.loop = false
        video.controls = true

        parent.classList.remove('jonnitto-prettyembed--autoplay')
        parent.classList.add('jonnitto-prettyembed--init', 'jonnitto-prettyembed--play')
      } else {
        video.autoplay = true
        video.loop = true
        video.controls = false

        // Setze die autoplay-Klasse wieder, wenn sie vorher da war
        if (hadAutoplayClassInitially) {
          parent.classList.add('jonnitto-prettyembed--autoplay')
          parent.classList.remove('jonnitto-prettyembed--init', 'jonnitto-prettyembed--play')
        }

        // Manuell abspielen, wenn Autoplay aktiviert ist
        video.play().catch(error => {
          console.warn('Autoplay konnte nicht ausgeführt werden:', error)
        })
      }
    }

    // Aktualisiere das Video, um Änderungen zu übernehmen
    video.load()
  }

  // Verstecke Bilder, falls notwendig
  if (localStorage.getItem('hide-images') === 'true') {
     
    for (const img of document.querySelectorAll('img')) img.style.display = 'none'
    hideImagesButton?.classList.add('active')
  }
}

function toggleImages () {
  const images = document.querySelectorAll('img')
  const html = document.documentElement
  html.classList.toggle('hide-images')
  const isActive = html.classList.contains('hide-images')

  for (const img of images) {
    img.style.display = isActive ? 'none' : 'block'
  }

  if (isActive) {
    localStorage.setItem('hide-images', 'true')
  } else {
    localStorage.removeItem('hide-images')
  }

  // Event für alle Subscriber dispatchen
  document.dispatchEvent(new CustomEvent('a11y:imagesToggled', { detail: { isActive } }))
}

// Funktion zum Anwenden gespeicherter Einstellungen

// Reset-Einstellungen zurücksetzen
function resetSettings () {
  const html = document.documentElement // Zugriff auf den <html> Tag
  html.classList.remove('high-contrast', 'large-text', 'disable-animations')
   
  for (const img of document.querySelectorAll('img')) img.style.display = 'block'

  // Videos zurücksetzen
  const videos = document.querySelectorAll('video')
  for (const video of videos) {
    video.autoplay = true
    video.loop = true
    video.controls = false
    video.play() // Spiele das Video ab
  }

  for (const button of document.querySelectorAll('.option-button')) button.classList.remove('active')

  // Entferne alle gespeicherten Einstellungen
  localStorage.clear()
}

// Menü anzeigen, wenn auf das Icon geklickt wird
document.querySelector('#menuIcon')?.addEventListener('click', () => {
  document.querySelector('#accessibilityMenu').style.display = 'block'
  document.querySelector('#menuIcon').style.display = 'none'
})

// Menü schließen und das Icon wieder anzeigen
document.querySelector('#closeMenu')?.addEventListener('click', () => {
  document.querySelector('#accessibilityMenu').style.display = 'none'
  document.querySelector('#menuIcon').style.display = 'block'
})

// Event-Listener für die Barrierefreiheitsfunktionen (nur Funktion aufrufen, Event kümmert sich um UI)
for (const button of document.querySelectorAll('.highContrastButton')) {
  button.addEventListener('click', toggleContrast)
}

document.querySelector('#highContrastButton')?.addEventListener('click', toggleContrast)
largeTextButton?.addEventListener('click', toggleLargeText)
playAnimationsButton?.addEventListener('click', toggleAnimations)
hideImagesButton?.addEventListener('click', toggleImages)
document.querySelector('#resetSettings').addEventListener('click', resetSettings)

// Event Subscriber - aktualisiert alle Button-Status
document.addEventListener('a11y:largeTextToggled', (event) => {
  largeTextButton?.classList.toggle('active', event.detail.isActive)
})

document.addEventListener('a11y:contrastToggled', (event) => {
  document.querySelector('#highContrastButton')?.classList.toggle('active', event.detail.isActive)
  for (const button of document.querySelectorAll('.highContrastButton')) {
    button.classList.toggle('active', event.detail.isActive)
  }
})

document.addEventListener('a11y:animationsToggled', (event) => {
  playAnimationsButton?.classList.toggle('active', event.detail.isActive)
})

document.addEventListener('a11y:imagesToggled', (event) => {
  hideImagesButton?.classList.toggle('active', event.detail.isActive)
})

// Anwenden gespeicherter Einstellungen beim Laden der Seite
window.addEventListener('load', applyStoredSettings)


// Export für globale Verwendung in anderen Bundles
globalThis.toggleLargeText = toggleLargeText
globalThis.toggleContrast = toggleContrast
globalThis.toggleAnimations= toggleAnimations
globalThis.toggleImages= toggleImages